module.exports = {
  // 公共语言档
  Common: {
    person: "人",
    each: "个",
    page: "每页 ",
    item: " 条",
    currentPage: "当前页",
    woman: "女",
    man: "男",
    noSex: "待定",
    btn_complete: "完成",
    btn_confirm: "确定",
    btn_cancel: "取消",
    btn_export: "导出",
    exportTips: "报表内容为空，不可导出",
    btn_submit: "提交",
    btn_edit: "编辑",
    tips: "提示",
    options: "不限",
    operatesLabel: "操作",
    closeTips: "确认关闭？",
    delTips: "确定要删除本条信息吗？",
    errorMessage: "请填写所有的必填项！",
    editTableTitle: "编辑列",
    editTableTitles: ["已显示列", "未显示的列"],
    workMenu: "功能菜单",
    empty_tips: "暂时没有内容哦",
    personalInfo_tips: "为未同意个人资料保护法",
    age: "岁",
    times: "次",
    keyWord: "关键词：",
    startTime: "开始时间",
    endTime: "结束时间",
    to: "至",
    create_time: "创建时间",
    loadTip1: "加载中……",
    loadTip2: "加载超时",
    loadTip3: "请重新登录！",
    loadTip4: "加载失败",
  },
  // 组件中文字---start
  Header: {
    title: "校务招生CRM",
    menu1: "校务中心",
    menu2: "招生CRM",
    menu3: "家园互动",
    menu4: "控制中心",
    nav_title1: "招生",
    nav_title2: "CRM",
    exchange: "切换",
    dropdown_item1: "个人信息",
    dropdown_item2: "联系人",
    dropdown_item3: "切换职务",
    dropdown_item4: "退出登录",
    s_title1: "请选择您要进入的学校",
    placeholder1: "请选择区域",
    placeholder2: "省",
    placeholder3: "市",
    placeholder4: "请输入校园编号,校园名称",
    message_labe1: "最新消息",
    message_labe2: "历史信息",
    message_labe3: "设置提醒",
    contact_label1: "招生联系人",
    myInfo_label1: "个人资料",
    myInfo_label2: "基本信息",
    label_text1: "姓名：",
    info_placeholder1: "请输入姓名",
    label_text2: "手机号：",
    info_placeholder2: "请输入手机号",
    label_text3: "头像：",
    post_label1: "选择分校",
    post_label2: "选择职务",
    slider_nav_name1: "切换集团",
    slider_nav_name2: "教学视频",
    slider_nav_name3: "常见问题",
    slider_nav_name4: "查看文档",
    slider_nav_name5: "在线咨询",
    video_title: "观看教学视频",
    word_title1: "查看文档",
    word_title2: "文档列表",
    word_title3: "文档详情",
    mmd: '毛名单',
    searchTxt: '名单检索'
  },
  Calendar: {
    title: "日程",
    label_text1: "年",
    label_text2: "月",
    placeholder1: "选择月",
    btn_text1: "创建",
    wk1: "日",
    wk2: "一",
    wk3: "二",
    wk4: "三",
    wk5: "四",
    wk6: "五",
    wk7: "六",
    btn_text2: "展开全月",
    btn_text3: "收起全月",
    label_text3: "新建日程",
    label_text4: "时间：",
    placeholder2: "设置时间",
    placeholder3: "请填写内容",
    rules_text1: "请选择设置时间",
    rules_text2: "请填写内容",
  },
  Aims: {
    title: "新建招生目标",
    title2: "编辑目标",
    s_title1: "基础资料",
    s_title2: "请设置参与目标考核的员工",
    label_text1: "目标名称：",
    placeholder1: "请输入招生目标名称",
    label_text2: "开始时间：",
    placeholder2: "目标开始时间",
    label_text3: "结束时间：",
    placeholder3: "目标结束时间",
    label_text4: "跟踪人次：",
    placeholder4_1: "请输入最少人次",
    placeholder4_2: "请输入达标人次",
    label_text5: "柜询/试听人次：",
    placeholder5_1: "柜询/试听最少人数",
    placeholder5_2: "柜询/试听达标人数",
    label_text6: "学员转正人次：",
    placeholder6_1: "学员转正最少人次",
    placeholder6_2: "学员转正达标人次",
    label_text7: "自主招生跟踪最大人次：",
    placeholder7: "请输入自主招生跟踪最大人次",
    label_text8: "选择职工：",
    placeholder8: "已选择",
    placeholder9: "人",
    tooltips_cont:
      "自主跟进上限人数，指的是招生负责人在招生有效名单自主跟进的最大人数，超过此设置的人数，不能自主跟进，需让主管或者校长分配有效名单",
    rule_tips1: "不能为空",
    rule_tips1_2: "请输入正确的格(非零的正整数)",
    rule_tips2: "请输入招生目标名称",
    rule_tips3: "长度在 2 到 30 个字符",
    rule_tips4: "请选择目标开始时间",
    rule_tips5: "请选择目标结束时间",
    rule_tips6: "请输入自主招生跟踪最大人次",
    rule_tips7: "最少人次不能大于达标人次",
    rule_tips8: "达标人次不能小于最少人次",
    rule_tips9: "最少人数不能大于达标人数",
    rule_tips10: "达标人数不能小于最少人数",
    rule_tips11: "最少人次不能大于达标人次",
    rule_tips12: "达标人次不能小于最少人次",
  },
  User: {
    img_text1: "上传头像",
    s_title1: "基础信息",
    s_title2: "重复记录",
    s_title3: "家庭联系信息",
    s_title4: "招生信息",
    s_title5: "意向课程信息",
    s_title6: "备注",
    s_title7: "跟踪记录",
    s_title8: "柜询记录",
    s_title9: "试听记录",
    s_title10: "跟进基础信息",
    s_title11: "最近两次跟进记录",
    s_title12: "基础信息",
    man: "男",
    woman: "女",
    label_text1: "中文名：",
    placeholder1: "请输入中文名",
    label_text2: "英文名：",
    placeholder2: "请输入英文名",
    label_text3: "性别：",
    placeholder3: "请选择性别",
    label_text4: "手机号：",
    placeholder4: "请输入手机号",
    label_text5: "出生日期：",
    placeholder5: "选择日期",
    label_text6: "身份证号：",
    placeholder6: "请输入身份证号",
    label_text7: "家庭信息:",
    placeholder7_1: "亲属关系",
    placeholder7_2: "亲属姓名",
    placeholder7_3: "请输入手机号",
    label_text8: "招生来源类型：",
    placeholder8: "请选择招生来源类型",
    options1: ["外部招生", "内招生", "专案招生"],
    label_text9: "招生渠道类型：",
    placeholder9: "请选择招生渠道类型",
    label_text10: "招生渠道明细：",
    placeholder10: "请选择招生渠道明细",
    label_text11: "意向星级：",
    label_text12: "介绍人：",
    placeholder12: "请输入介绍人",
    label_text13: "主负责人：",
    placeholder13: "请选择主负责人",
    label_text14: "协助负责人：",
    placeholder14: "请选择协助负责人",
    label_text15: "意向课程:",
    placeholder15: "请选择意向课程",
    label_text16: "特殊备注：",
    placeholder16: "请输入备注信息",
    label_text17: "主要联系人：",
    label_text18_1: "家长姓名：",
    label_text18_2: "家长身份：",
    label_text18_3: "家长手机号：",
    label_text18_4: "附近就读学校：",
    label_text18_4_ph: "请选择附近就读学校",
    label_text18_5: "省市区：",
    label_text18_5_ph1: "请选择省",
    label_text18_5_ph2: "请选择市",
    label_text18_5_ph3: "请选择区",
    label_text19: "客户状态：",
    btn_text1: "设置为主要联系人",
    btn_text2: "继续添加",
    tips1: "当前有重复记录",
    record_text1: "岁",
    record_text2: "负责人：",
    record_text3: "客户状态：",
    rule_tips1: "手机号不能为空",
    rule_tips2: "请输入正确的手机号",
    rule_tips3: "请输入正确的身份证号",
    rule_tips4_1: "请输入中文名",
    rule_tips4_2: "长度在 2 到 10 个字符",
    rule_tips5: "请输入英文名",
    rule_tips6: "请选择性别",
    rule_tips7: "请选择出生日期",
    rule_tips8: "请输入主负责人",
    rule_tips9: "请选择招生渠道类型",
    rule_tips10: "请选择招生渠道明细",
    message_tips: "上传头像图片只能是 JPG/PNG/GIF 格式!",
    see_btn_more: "更多",
    see_btn_bind: "绑定学员",
    tab_pane1: "基本信息",
    tab_pane2: "跟踪记录",
    tab_pane3: "柜询试听记录",
    tab_pane4: "跟进",
    tab_pane5: "绑定学员",
    follow_label1: "沟通类型：",
    follow_placeholder1: "请选择沟通类别",
    follow_label2: "沟通对象：",
    follow_placeholder2: "请选择沟通对象",
    follow_label3: "沟通效果：",
    follow_options1: ["有效沟通", "无效沟通"],
    follow_label4: "意向星级：",
    follow_label5: "本次跟进类型：",
    follow_label166: "跟进班组：",
    follow_options2: ["柜询", "试听", "普通回访", "已确认无意向", "无效名单"],
    follow_label6: "试听类型：",
    follow_placeholder6: "请选择试听类型",
    follow_options3: ["公开课试听", "插班试听"],
    follow_label7: "接待人：",
    follow_placeholder7: "请选择接待人",
    follow_label8: "柜询类型：",
    follow_placeholder8: "请选择柜询类型",
    follow_options4: ["普通柜询", "能力测试"],
    follow_label9: "柜询到访日：",
    follow_placeholder9: "请选择到访日期",
    follow_label10: "试听日期：",
    follow_placeholder10: "请选择试听日期",
    follow_label11: "试听班级：",
    follow_placeholder11_1: "请选择试听班级",
    follow_placeholder11_2: "请输入试听班级",
    follow_label12: "回访日期：",
    follow_placeholder12: "请选择回访日期",
    follow_label13: "无意向类型：",
    follow_placeholder13: "请选择无意向类型",
    follow_options5: ["已报异业", "强烈抵触", "其他"],
    follow_label14: "沟通内容：",
    follow_placeholder14_1: "请选择模板",
    follow_placeholder14_2: "请输入沟通内容",
    follow_label15: "下次跟进类型：",
    follow_placeholder15: "请选择下次跟进类型",
    follow_options6: ["普通跟进", "提醒跟进"],
    follow_label16: "下次跟进日期：",
    follow_placeholder16: "请选择下次跟进日期",
    follow_rule1: "请输入接待人",
    follow_rule2: "请选择试听班级",
    follow_rule3: "请选择到访日期",
    follow_rule4: "请选择试听日期",
    follow_rule5: "请输入沟通内容",
    baseInfo: "基础信息",
    BindShip: "绑定关系：",
    noBindRecord: "暂无绑定学员记录",
    followRecord: "跟踪记录",
    tryDate: "试听日期：",
    tryClass: "试听班级：",
    guiDate: "柜询日期：",
    nextFollowDate: "下次跟进日期：",
    typecname: "跟进班组：",
    followSchool: "跟踪学校：",
    communiteContent: "沟通内容：",
    noFollowRecord: "暂无跟踪记录",
    noFollowRecord2: "暂无跟进记录",
    CounterRecord: "柜询记录",
    tryRecord: "试听记录",
    btn_text3: "跟进",
    btn_text4: "阅",
    btn_text5: "已阅",
    btn_text6: "回复",
    replay_placeholder: "请输入回复内容",
    label_text20: "于",
    label_card: "身份证号:",

    label_text21: "是否有推荐人：",
    recommend: ["是", "否"],
    label_text22: "推荐人：",
    label_text23: "就读校区：",
    placeholder18: "推荐人姓名、联系电话、学员编号搜索",
    rule_tips11: "请选择是否推荐名单",
    rule_tips12: "请选择推荐人",
    tips: "未设置",
    errorMessage1: "请输入推荐人姓名、联系电话、学员编号搜索",
    ab: "添加标签",
    aa: "常用标签",
    ac: "外拨记录",
    ae: "标签：",
    af: "客户当前意向星级",
    ag: "跟进班种：",
    ah: "请选择跟进班种",
    ai: "沟通模板：",
    aj: "沟通内容：",
    ak: "请选择常用模板",
  },
  Class: {
    title1: "公开课试听",
    title2: "插班试听",
    S_title: "选择试听班级",
    label_text1: "课程名称：",
    placeholder1: "请输入课程名称",
    label_text2: "选择教师：",
    placeholder2: "请选择教师",
    label_text3: "上课日期：",
    placeholder3: "选择日期",
    placeholder4: "选择课程名称",
    label_text4: "当前已选择：",
    label_text5: "上课日期：",
    label_text6: "上课时间：",
  },
  Report1: {
    errorMessage1: "报表内容为空，不可导出",
    placeholder1: "开始日期",
    placeholder2: "至",
    placeholder3: "结束日期",
    placeholder4: "选择月份",
    label_text1: "招生渠道类型：",
    placeholder5: "招生渠道类型",
    label_text2: "招生渠道明细：",
    placeholder6: "招生渠道明细",
    label_text3: "名单状态：",
    placeholder7: "名单状态",
    options: [
      "待跟踪",
      "持续跟踪",
      "已柜询",
      "已试听",
      "已转正",
      "无意向",
      "无效名单",
    ],
  },
  Table: {
    label_text1: "空闲",
    label_text2: "有课",
    label_text3: "外地",
    label_text4: "本地",
    noreadTips: "未读",
  },
  active: {
    publishActive: "发布活动",
    confirmPublish: "确认发布",
    confirmEdit: "确定修改",
    baseInfo: "基本信息",
    aboutUs: "关于我们",
    CustomDetails: "自定义详情",
    activeName: "活动名称:",
    activeNamePlaceHold: "请输入活动名称",
    nameOnly: "活动名称唯一",
    activeType: "活动类型:",
    normal: "普通活动",
    EnrollmentStu: "招生券活动",
    activeTopic: "活动主题:",
    activeTopicPlaceHold: "请输入活动主题",
    activeWHTopic: "主图宽高:",
    activeWPlaceHold: "请输入主图宽",
    activeHPlaceHold: "请输入主图高",
    activeTime: "活动时间:",
    activeStartTime: "活动开始时间",
    activeEndTime: "活动结束时间",
    activeEnd: "活动结束不可再参加活动",
    channelType: "招生渠道类型:",
    channelTypePlaceHold: "请选择招生渠道类型",
    channelDetail: "招生渠道明细:",
    channelDetailPlaceHold: "请选择招生渠道明细",
    activeTemlate: "活动模板：",
    systemTemlate: "系统模板",
    customTemlate: "自定义模板",
    selectTemlate: "请选择活动模板",
    previewTemlate: "预览模板",
    urlPlaceHold: "请输入自定义模板的URL链接",
    phone: "联系电话：",
    phonePlaceHold: "请输入联系电话",
    address: "联系地址：",
    addressPlaceHold: "请输入联系地址",
    fileImg: "上传主图：",
    fileImgPlaceHold: "请上传主图",
    activeDetail: "活动详情：",
    viewPriew: "查看预览图",
    activeRule: "活动规则：",
    activeRulePlaceHold: "请输入活动规则",
    shareDescrible: "分享描述：",
    shareDescriblePlaceHold: "请输入分享描述",
    shareImg: "分享图片：",
    shareImgPlaceHold: "请上传分享图片",
    rule_tips1: "手机号不能为空",
    rule_tips2: "请输入正确的手机号",
    rule_tips3: "请输入招生活动名称",
    rule_tips4: "长度在 2 到 50 个字符",
    rule_tips51: "请选择活动类型",
    rule_tips6: "请选择活动开始时间",
    rule_tips7: "请输入活动主题",
    rule_tips8: "请选择活动结束时间",
    rule_tips9: "请选择招生渠道类型",
    rule_tips10: "请选择招生渠道明细",
    rule_tips11: "请输入联系电话",
    rule_tips12: "开始时间和结束时间不能相同",
  },
  // 海报活动组件
  posterActive: {
    publishActive: "发布活动",
    confirmPublish: "确认发布",
    confirmEdit: "确定修改",
    activeEnd: "活动结束不可再参加活动",
    nameOnly: "活动名称唯一",
    item_text1: "海报活动名称：",
    form_phoder1: "请输入海报活动名称",
    item_text2: "海报活动主题：",
    form_phoder2: "请输入海报活动主题",
    item_text3: "活动时间：",
    form_phoder3_1: "开始时间",
    form_phoder3_2: "至",
    form_phoder3_3: "结束时间",
    item_text4: "招生渠道类型：",
    form_phoder4: "选择招生渠道类型",
    item_text5: "招生渠道明细：",
    form_phoder5: "选择招生渠道明细",
    item_text6: "上传海报封面图：",
    form_phoder6: "请上传海报封面图",
    item_text7: "选择海报模版：",
    form_phoder7: "请选择海报模版",
    item_text8: "分享描述：",
    form_phoder8: "请输入分享描述",
    item_text9: "分享图片：",
    form_phoder9: "请上传分享图片",
    item_text10: "上传海报主图：",
    form_phoder10: "请上传海报主图",
    item_text11: "活动介绍：",
    form_phoder11: "请输入活动介绍",
    rule_tips1: "手机号不能为空",
    rule_tips2: "请输入正确的手机号",
    rule_tips3: "请输入海报活动名称",
    rule_tips4: "长度在 2 到 50 个字符",
    rule_tips51: "请选择活动类型",
    rule_tips6: "请选择活动开始时间",
    rule_tips7: "请输入海报活动主题",
    rule_tips8: "请选择活动结束时间",
    rule_tips9: "请选择招生渠道类型",
    rule_tips10: "请选择招生渠道明细",
    rule_tips11: "请输入联系电话",
  },
  // 组件中文字---end
  home: {
    aa: "首页",
    ab: "统计信息",
    ac: "招生统计",
    ad: "至",
    a1: "开始日期",
    ae: "结束日期",
    af: "选择校园职工筛选",
    ag: "招生转化统计",
    ah: "选择校园职工筛选",
    ai: "招生有效名单转化",
    aj: "选择校园职工筛选",
    ak: "有效名单转化为意向客户数量 / 转化率",
    al: "意向客户转化为试听客户数量 / 转化率",
    am: "意向转化为正式客户数量 / 转化率",
    an: "有效名单转无意向客户数量/转化率",
    ao: "本周招生跟踪提醒",
    ap: "更多",
    aq: "已跟进",
    ar: "未跟进",
    aw: "上次跟进时间：",
    as: "本周暂无招生跟踪提醒",
    at: "招生跟踪提醒记录",
    au: "关键词：",
    av: "请输入姓名查询",
    aww: "提醒时间：",
    ax: "我的跟踪记录",
    ay: "7日内",
    az: "30日内",
    ba: "高级筛选",
    bb: ["7日内", "30日内", "高级筛选"],
    bc: "新增客户名单数",
    bd: "新增意向客户",
    be: "新增名单无意向",
    bf: "新增柜询客户",
    bg: "新增试听学员",
    bh: "新增正式学员",
    bi: "操作",
    bj: "不限",
    bk1: "01.毛名单数",
    bk: "02.招生有效名单",
    bl: "02.意向客户",
    bm: "03.柜询客户",
    bn: "04.试听客户",
    bo: "05.转正客户",
    bp: "招生转化率",
    bq: "确认关闭？",
    br: "请选择跟进类型！",
    bs: "每页 ",
    bt: " 条",
    bu: "当前页",
    person: "人",
    each: "个",
    data: [
      "01.毛名单数",
      "02.意向客户",
      "03.柜询客户",
      "04.试听客户",
      "05.转正客户",
    ],
    gmcRosterTitle: "集团名单提醒",
    gmcRosterPlaceholder: "选择名单状态",
    gmcRosterTab1: "全部",
    gmcRosterTab2: "更新",
    gmcRosterTab3: "柜询",
    gmcRosterTab4: "试听",
    gmcRosterPopTitle: "我的集团名单提醒详情",
    gmcRosterTip: "本周及上周导入名单提醒",
    listTitle: "有效名单转化为意向客户数量/转化率",
    ca: "新增待跟踪意向客户",
    cb: "新增无意向客户",
    cd: "新增邀约客户",
    ce: "新增正式学员",
    cc: "暂无集团名单提醒",
    listTitle1:'毛名单转化为有效客户数量/转化率',
    cf:'教师业绩统计',
    cg:'请选择班组',
  },
  Goalmanage: {
    aa: "招生活动管理",
    ab: "发布活动",
    ac: "开始日期",
    ad: "至",
    ae: "结束日期",
    af: "创建人：",
    ag: "创建人选择",
    ah: "请输入招生活动名称",
    ai: "查询",
    aj: "扫码分享活动",
    ak: "查看活动",
    al: "编辑",
    am: "删除活动",
    an: "确定删除该活动？",
    ao: "取消",
    ap: "确定",
    aq: "这里是UE测试",
    ar: "发布活动",
    as: "编辑活动",
    at: "预览",
    au: "删除",
    av: "复制活动",
    aw: "长度在 2 到 10 个字符",
    ax: "请选择活动开始时间",
    ay: "请选择活动结束时间",
    az: "不限",
    ba: "确认关闭？",
    bb: "每页 ",
    bc: " 条",
    bd: "当前页:",
    be: "招生目标管理",
    bf: "新增目标",
    bg: "请输入招生目标名称",
    bh: "查看目标",
    bi: "目标基本信息",
    bj: "基础资料",
    bk: "目标名称：",
    bl: "开始时间：",
    bm: "结束时间：",
    bn: "跟踪人次：",
    bo: "最少",
    bp: "达标",
    bq: "柜询/试听人次：",
    br: "学员转正人次：",
    bs: "自主招生跟踪最大人次：",
    bt: "参与目标的考核员工",
    bu: "选择职工：",
    bv: "女",
    bw: "男",
    bsk: "目标完成状况",
    by: "目标完成率",
    bz: "统计维度：",
    ca: "参与目标的员工",
    cb: "转正人次",
    cc: "删除目标",
    cd: "确定删除该目标？",
    ce: "操作",
    cf: "查看",
    cg: "删除",
    ch: "跟踪人次完成率",
    ci: "跟踪人次未完成率",
    cj: "柜询/试听人次完成率",
    ck: "柜询/试听人次未完成率",
    cl: "人",
    cm: "转正人次",
    cn: "请填写所有的必填内容！",
  },
  Crmactivemanage: {
    aa: "招生活动管理",
    ab: "发布活动",
    ac: "活动时间段：",
    ad: "开始日期",
    ae: "至",
    af: "结束日期",
    ag: "创建人：",
    ah: "创建人选择",
    ai: "活动类型：",
    aj: "选择招生活动类型",
    ak: "不限",
    al: "普通活动",
    am: "招生券活动",
    an: "招生渠道类型：",
    ao: "选择招生渠道类型",
    ap: "招生渠道明细：",
    aq: "选择招生渠道明细",
    ar: "请输入招生活动名称",
    as: "查询",
    at: "网页二维码：",
    au: "小程序二维码：",
    av: "扫码分享活动",
    aw: "网页版链接：",
    ax: "查看活动",
    ay: "编辑",
    az: "删除活动",
    ba: "确定删除该活动？",
    bb: "取消",
    bc: "确定",
    bd: "这里是UE测试",
    be: "发布活动",
    bf: "编辑活动",
    bg: "操作",
    bh: "预览",
    bi: "删除",
    bj: "复制活动",
    bk: "请输入招生活动名称",
    bl: "长度在 2 到 10 个字符",
    bm: "请选择活动开始时间",
    bn: "请选择活动结束时间",
    bo: "确认关闭？",
    bp: "每页 ",
    bq: " 条",
    br: "当前页: ",
    bs: "招生名单管理",
    bt: "招生券名称",
    bu: "请选择招生券名称",
    bv: "请输入姓名/主要联系电话/招生券编号",
    bw: "招生券管理",
    bss: "生成招生券",
    by: "导出",
    bz: "使用状态",
    ca: "请选择状态",
    cb: "未使用",
    cc: "已使用",
    cd: "请输入招生券名称搜索",
    ce: "招生券描述",
    cf: "请输入招生券名称",
    cg: "请输入招生券描述，字数控制在50字以内 0/50",
    ch: "有效时间",
    ci: "招生券个数",
    cj: "请输入招生券个数",
    ck: "请选择开始日期",
    cl: "请选择结束日期",
    cm: "报表内容为空，不可导出",
    cn: "请输入活动名称",
    co: "招生名单",
    cp: "扫码分享活动",
    // 海报管理
    title1: "发布海报活动",
    title2: "编辑海报活动",
    title3: "海报活动",
    pageTitle: "海报活动管理",
    placeholder1: "请输入海报活动名称",
    label_text1: "发布人：",
    placeholder2: "选择发布人",
    btn_see: "预览",
    btn_copy: "复制活动",
    btn_del: "删除",
    dialog_title: "复制活动",
    dialog_cont: "确定复制该活动？",
  },
  Admissioncue: {
    aa: "招生有效名单",
    ab: "导入有效名单",
    ac: "新增招生有效名单",
    ad: "招生渠道类型：",
    ae: "招生渠道类型",
    af: "不限",
    ag: "活动：",
    ah: "请选择活动名称",
    ai: "招生渠道明细：",
    aj: "请选择招生渠道明细",
    ak: "名单类型：",
    al: "请选择名单类型",
    am: "不限",
    an: "未确认无意向名单",
    ao: "请输入中/英文名、手机号",
    ap: "查询",
    aq: "请输入家属手机号",
    ar: "批量分配",
    as: "转为我的意向客户",
    at: "批量无意向",
    au: "提示",
    av: "立即跟进",
    aw: "暂不跟进",
    ax: "确定",
    ay: "绑定学员",
    az: "绑定学员名称：",
    ba: "请输入学员名称后选择",
    bb: "绑定关系：",
    bc: "请选择绑定关系",
    bd: "分配",
    be: "主负责人：",
    bf: "请选择主负责人",
    bg: "副负责人：",
    bh: "请选择副负责人",
    bi: "目标学校：",
    bj: "请选择目标学校",
    bk: "异动原因：",
    bl: "请选择异动原因",
    bm: "备注：",
    bn: "请输入异动原因",
    bo: "已显示列",
    bp: "未显示的列",
    bq: "确定删除该名单？",
    br: "待跟踪",
    bs: "持续跟踪",
    bt: "已柜询",
    bu: "已试听",
    bv: "已转正",
    bw: "无意向",
    bsw: "编辑招生有效名单",
    by: "招生有效名单",
    bz: "今日新增招生有效名单",
    ca: "操作",
    cb: "我要跟进",
    cc: "转校",
    cd: "普通回访",
    ce: "柜询",
    cf: "试听",
    cg: "转正",
    ch: "跟进无意向",
    ci: "显示 列切换",
    cj: "列变化",
    ck: "请填写所有的必填内容！",
    cl: "确认关闭？",
    cm: "每页 ",
    cn: " 条",
    co: "当前页: ",
    cp: "导入招生有效名单",
    cq: "上传文件",
    cr: "预览招生有效名单",
    cs: "导入结果",
    ct: "将文件拖到此处，或",
    cu: "点击上传",
    cv: "下载导入招生有效名单模板",
    cw: "操作步骤",
    csl:
      "1.首次使用导入功能或者没有导入模版，请点击上传文件下方的链接下载对应的导入模板，请严格参照模板导入数据，否则可能无法导入数据",
    cy: "2.上传文件，导入数据",
    cz: "上传中（",
    da: "正在上传并解析数据，请稍等…",
    db: "上一步",
    dc: "下一步",
    dd: "继续上传",
    de: "完成",
    df: "上传文件",
    dg: "预览招生有效名单",
    dh: "导入结果",
    di: "本次导入成功数据",
    dj: "本次导入失败数据",
    dk: "条",
    dl: "失败数据列表",
    dm: "地区",
    dn: "园所编号",
    do: "姓名",
    dp: "主要联系手机",
    dq: "所在地址",
    dr: "电销姓名",
    ds: "备注",
    dt: "招生有效名单名称",
    du: "招生有效名单ID",
    dv: "失败原因",
    dw: "名单检索",
    dss: "请输入完整的手机号、姓名，多个手机号或者姓名以|符号分割查询",
    dy: "编辑列",
    dz: "取消转正后，将会删除转正业绩，需要重新转正！",
    ea: "上传头像图片只能是 JPG 格式!",
    eb: "上传头像图片大小不能超过 2MB!",
    cac: "不限",
    tips1: "您有",
    tips2: "条名单更新信息未读提醒，请及时查看更新信息",
    cad: "新消息：",
    cae: "请选择是否新消息",
    caf: "是",
    cag: "否",
    plzwmmd: '批量转为毛名单'
  },
  Customersmanage: {
    aa: "意向客户管理",
    ab: "新增意向客户",
    ac: "意向星级：",
    ad: "客户状态：",
    ae: "请选择客户状态",
    af: "活动：",
    ag: "请选择活动名称",
    ah: "主负责人：",
    ai: "选择主负责人",
    aj: "不限",
    ak: "协助负责人：",
    al: "选择协助负责人",
    am: "请输入中/英文名、手机号、主要联系手机",
    an: "查询",
    ao: "转回招生有效名单",
    ap: "批量无意向",
    aq: "绑定学员",
    ar: "绑定学员名称：",
    as: "请输入学员名称后选择",
    at: "绑定关系：",
    au: "请选择绑定关系",
    av: "确定",
    aw: "编辑列",
    ax: "已显示列",
    ay: "未显示的列",
    az: "提示",
    ba: "转正学员",
    bb: "学员编号：",
    bc: "请输入学员编号",
    bd: "课程别：",
    be: "请选择首次报名课程别",
    bf: "转正日期：",
    bg: "请选择转正日期",
    bh: "备注：",
    bi: "备注信息，字数控制在50字左右",
    bj: "取 消",
    bk: "取消",
    bl: "确定删除该名单？",
    bm: "我的意向客户",
    bn: "此客户不属于您的意向客户，不可以跟进",
    bo: "请输入学员编号",
    bp: "请选择课程别",
    bq: "请选择转正日期",

    br: "不限",
    bs: "待跟踪",
    bt: "持续跟踪",
    bu: "已柜询",
    bv: "已试听",
    bvN1: "待柜询",
    bvN2: "待试听",
    bvN3: "未柜询",
    bvN4: "未试听",
    bvN5: "无意向待审核",
    bvN6: "无意向",
    bvN7: "无效名单",
    bvN8: "已转正",

    bw: "编辑意向客户",
    bss: "操作",
    by: "跟进",
    bz: "转正",
    ca: "列变化",
    cb: "确认关闭？",
    cc: "此客户已转正，不可以跟进！",
    cd: "此客户不属于您的意向客户，不可以跟进",
    ce: "请选择跟进类型！",
    cf: "显示 列切换",
    cg: "请填写所有的必填内容！",
    ch: "每页 ",
    ci: " 条",
    cj: "当前页: ",
    ck: "上传头像图片只能是 JPG 格式!",
    cl: "上传头像图片大小不能超过 2MB!",
    caa: "渠道：",
    cab: "请选择渠道",
    cac: "不限",
    tabs1: "我的意向客户",
    tabs2: "TMK协助跟踪",
    tips1: "您有",
    tips2: "条名单更新信息未读提醒，请及时查看更新信息",
    cad: "新消息：",
    cae: "请选择是否新消息",
    caf: "是",
    cag: "否",
    cba: '创建时间',
    cbb: '最后跟踪时间',
    cbc: '请选择是否柜询',
    cbd: '请选择是否试听',
    cbe: '请选择活动',
    cbf: '请选择负责人',
    cbg: '请选择渠道类型',
    cbh: '请选择渠道明细',
    cbi: '请选择是否有新提醒',
    cbj: '请选择接通状态',
    cbk: '跟进次数小于等于',
    cbl: '是否七日内未跟踪名单',
    cbm: '可检索中英文名、手机号、标签名称、意向课程信息、接触点',
    cbn: '申请变更渠道',
    daa: '试听邀约课表',
    dab: '请选择班组',
    dac: '请选择班种',
    dad: '可检索班级名称',
    dae: '普通公开课',
    daf: '试读公开课',
    dba: '更改渠道记录',
    dbb: '申请时间',
    dbc: '请选择审核状态',
    dbd: '请选择目标渠道类型',
    dbe: '中英文名、手机号、主要联系手机',
    dbf: '处于渠道保护期',
    dbg: '关闭',
    dbh: '请选择目标渠道明细',
    dbj: '渠道变更记录',
    dbk: '申请变更',
    dbl: '变更为',
    dbm: '申请人',
    dbn: '申请变更时间',
    dbo: '备注',
    dbp: '附件',
    dbr: '图片',
    eaa: '申请变更渠道',
    eab: '确定',
    eac: '该名单来源渠道处于保护期，不可随意更改，申请后审核通过几率不是很大喔～请知晓',
    ead: '原渠道类型：',
    eae: '原渠道明细：',
    eaf: '目标渠道类型：',
    eag: '请选择目标渠道类型',
    eah: '目标渠道明细：',
    eaj: '请选择目标渠道明细',
    eak: '变更时间：',
    eal: '请选择变更时间',
    eam: '上传附件：',
    ean: '请上传图片',
    eao: '更改原因：',
    eap: '请输入更改原因',
  },
  Invitationauditionmanage: {
    aa: "试听管理",
    ab: "试听班级：",
    ac: "不限",
    ad: "试听日期：",
    ae: "开始日期",
    af: "至",
    ag: "结束日期",
    ah: "主负责人：",
    ai: "选择主负责人",
    aj: "试听类型：",
    ak: "请选择试听类型",
    al: "不限",
    am: "公开课试听",
    an: "插班试听",
    ao: "请输入中/英文名、手机号",
    ap: "查询",
    aq: "学员已试听成功！",
    da: "学员已成功到访！",
    ar: "继续跟进",
    as: "暂不跟进",
    at: "选择原因：",
    au: "请选择原因",
    av: "请输入其它原因",
    aw: "绑定学员",
    ax: "绑定学员名称：",
    ay: "请输入学员名称后选择",
    az: "绑定关系：",
    ba: "请选择绑定关系",
    bb: "确定",
    bc: "编辑列",
    bd: "已显示列",
    be: "未显示的列",
    bf: "我的试听管理",
    bg: "新增试听学员",
    bh: "全部试听",
    bi: "取消试听",
    bj: "试听成功",
    bia: "未试听",
    bja: "已试听",
    bk: "操作",
    bl: "列变化",
    bm: "显示 列切换",
    bn: "确认关闭？",
    bo: "每页 ",
    bp: " 条",
    bq: "当前页: ",
    br: "柜询管理",
    bs: "到访日：",
    bt: "时间：",
    bu: "我的柜询管理",
    bv: "全部",
    bw: "未到访",
    db: "未到访原因",
    bss: "已到访过",
    by: "今日",
    bz: "昨日",
    ca: "本周",
    cb: "本月",
    cc: "已到访",
    cd: "未到访",
    ce: "确认关闭？",
    cf: "每页 ",
    cg: " 条",
    ch: "当前页: ",
    ea: "已到访",
    eh: "未到访",
    eb: "到访日",
    ec: "请选择主负责人",
    ed: "柜询日期",
    ee: "请选择柜询班组",
    ef: "请选择学生类型",
    eg: "请输入中/英文名、手机号、意向课程信息",
  },
  Registeredlist: {
    aa: "已报名名单",
    ab: "主负责人：",
    ac: "选择主负责人",
    ad: "协助负责人：",
    ae: "选择协助负责人",
    af: "报名课程：",
    ag: "请选择报名课程",
    ah: "不限",
    ai: "报名日期：",
    aj: "报名日期",
    ak: "招生渠道类型：",
    al: "招生渠道类型",
    am: "招生渠道明细：",
    an: "请选择招生渠道明细",
    ao: "请输入中英文名、手机号、编号、接触点、特殊学号",
    ap: "查询",
    aq: "编辑列",
    ar: "已显示列",
    as: "未显示的列",
    at: "确定",
    au: "提示",
    av: "取消转正后，将会删除转正业绩，需要重新转正！",
    aw: "取消",
    ax: "我的已转正名单",
    ay: "待审核",
    az: "无意向",
    ba: "操作",
    bb: "取消转正",
    bc: "列变化",
    bd: "显示 列切换",
    be: "确认关闭？",
    bf: "每页 ",
    bg: " 条",
    bh: "当前页: ",
    bi: "上传头像图片只能是 JPG 格式!",
    bj: "上传头像图片大小不能超过 2MB!",
    source_label: "招生来源类型",
    sourceList: ["外部招生", "内部招生", "专案招生"],
    dda:'已登记学籍名单',
    ddb:'申请渠道变更',
  },
  Losscustomermanage: {
    aa: "无效客户管理",
    ab: "招生渠道类型：",
    ac: "请选择招生渠道类型",
    ad: "请输入中/英文名、手机号",
    ae: "查询",
    af: "转为招生有效名单",
    ag: "是否确定此客户已无意向，无法再次跟进？",
    ah: "取消",
    ai: "确定",
    aj: "我的无效客户",
    ak: "待审核",
    al: "无意向",
    am: "操作",
    an: "不限",
    ao: "确认关闭？",
    ap: "每页 ",
    aq: " 条",
    ar: "当前页: ",
    as: "无意向客户管理",
    at: "我要跟踪",
    au: "审核",
    av: "我的无意向客户",
    ba:'创建时间',
    bb:'历史最高意向星级',
    bc:'请选择是否参与试听',
    bd:'可检索意向课程、标签',
    be:'转毛名单',
    bf:'转校',
    bg:'已选择',
    bh:'目标学校',
    bj:'请选择目标学校',
    bk:'异动原因',
    bl:'请输入异动原因',
    ca:'批量转毛名单',
    cb:'确认转毛名单？',
  },
  overageListManage: {
    title: "超龄名单",
    "s-title1": "设置超龄",
    "s-title2": "名单列表",
    "set-text1": "超龄日期 : ",
    "set-text2": "未设置",
    "set-text3": "立即设置",
    "set-text4": "备注 :",
    "set-text5": "超龄日期编辑后，立即生效，不影响已获取的超龄名单数据",
    empty: "暂无名单，请先设置超龄日期",
    ab: "招生渠道类型：",
    ac: "请选择招生渠道类型",
    ad: "请输入中/英文名、手机号",
    ae: "创建日期：",
    af: "开始日期",
    ag: "至",
    ah: "结束日期",
    ai: "查询",
    aj: "请选择出生日期",
    ak: "保存",
    a1: "批量转校",
    a2: "已选择",
    a3: "转校",
    a4: "目标学校",
    a5: "选择目标学校",
    a6: "异动原因",
    a7: "请填写异动原因",
  },
  Analysisreport: {
    aa: "招生渠道业绩统计表",
    ab: "渠道咨询报表",
    ac: "招生月度咨询统计表",
    ad: "个人招生业绩统计表",
    ae: "招生月度业绩统计表",
    af: "校招生咨询报表",
    ba: "招生分析类报表",
    bb: "选择名单创建日期",
    bc: "市场分析类报表",
    bd: "请选择招生渠道类型",
    be: "请选择招生渠道明细",
    bf: "请选择客户状态",
    bg: "请选择主负责人",
    bh: "请选择副负责人",
    ca: "跟踪分析类报表",
    cb: "沟通时间",
    cc: "请输入班组（课程科目）关键词检索",
    cd: "请选择是否邀约",
    ce: "请选择是否到访",
    cf: "跟进次数小于等于",
    cg: "请输入跟进次数值",
    ch: "请选择沟通类型",
    ci: "请输入学员中/英文名、主要联系电话",
    da: "活动分析类报表",
    db: "请输入招生活动名称、录入人姓名",
    fa: "管控分析类报表",
    fb: "请选择报名类型",
    fc: "可检索学生编号、学生姓名、负责人姓名",
    fd: "管控分析类报表",
    fe: "管控分析类报表",
  },
  Clientmanage: {
    aa: "客户管理",
    ab: "请输入中/英文名、手机号",
    ac: "查询",
    ad: "编辑列",
    ae: "已显示列",
    af: "未显示的列",
    ag: "确定",
    ah: "选择学校",
    ai: "请输入学校中/英文名、学校编号",
    aj: "查询",
    ak: "暂无数据",
    al: "取消",
    am: "确定",
    an: "操作",
    ao: "分配",
    ap: "学校名称",
    aq: "学校编号",
    ar: "学校地址",
    as: "时间安排",
    at: "不限",
    au: "请选择学校",
    av: "列变化",
    aw: "显示 列切换",
    ax: "确认关闭？",
    ay: "每页 ",
    az: " 条",
    ba: "当前页: ",
    bb: "上传头像图片只能是 JPG 格式!",
    bc: "上传头像图片大小不能超过 2MB!",
  },
  ListAllocationManagement:{
      aa:"待筛选毛名单",
      ab:"导入",
      ac:"创建时间",
      ad:"请选择渠道类型",
      ae:"请选择渠道明细",
      af:"请选择活动",
      ag:"可检索姓名、主要联系人、主要联系手机、标签名称、意向课程信息、接触点",
      ah:"批量分配筛选人",
      ai:"批量转有效名单",
      aj:"您已选择以下",
      ak:"条名单",
      al:"筛选人",
      am:"请选择筛选人",
      an:"是否确认转为有效名单？",
      ao:"导入毛名单",
      ap:"预览毛名单",
      aq:"下载导入毛名单模板",
      ar:"待分配有效名单",
      as:"新增有效名单",
      ba:"招生人员管理",
      bb:"负责人姓名搜索",
      bc:"名单交接",
      bd:"名单分配",
      be:"请选择校外招交接人",
      bf:"请选择校内招交接人",
      bg:"确认",
      mdfp: '名单分配'
  },
  Permission: {
    aa: "您即将跳转到招生CRM页面",
    ab: "秒后自动跳转",
    ac: "立刻前往",
    ad: "用户token失效",
    ae: "您没有CRM权限",
    af: "您当前没有CRM权限，请联系相关人员开通权限",
  },
  websiteBuilding: {
    aa: "功能正在建设中",
  },
  havePermission: {
    a1: "您即将跳转到招生CRM页面",
    a2: "秒后自动跳转",
    a3: "立刻前往",
  },
  noPermission: {
    a1: "您当前没有CRM权限，请联系相关人员开通权限",
  },
};
